import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Flex, Heading, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'

import { parseRouterQuery } from 'utils/parseRouterQuery'

export const NoResults: React.FC = () => {
  const { t } = useTranslation('search')
  const router = useRouter()
  const [searchTerm, setSearchTerm] = useState('')

  useEffect(() => {
    const searchTerm = parseRouterQuery(router.query.query)

    setSearchTerm(searchTerm)
  }, [router.query])

  return (
    <Flex marginY={['36px', null, '64px']} marginX={{ base: 'auto' }} direction="column" maxWidth="400px">
      <Heading as="h3" fontSize="md" fontWeight="500" wordBreak="break-word" lineHeight={{ base: 1.33, md: 1.2 }}>
        {t('noResults')} {searchTerm === '' ? `${t('thisSearch')}` : searchTerm}
      </Heading>
      <Text fontSize="sm" fontWeight="300" marginTop="16px">
        {t('noResultsCopy')}
      </Text>
    </Flex>
  )
}
